import { render, staticRenderFns } from "./MembersSection.vue?vue&type=template&id=4953b7e9&"
import script from "./MembersSection.vue?vue&type=script&lang=js&"
export * from "./MembersSection.vue?vue&type=script&lang=js&"
import style0 from "./MembersSection.vue?vue&type=style&index=0&id=4953b7e9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports